import styled from 'styled-components'

import { Typography } from 'components/Typography/Typography'
import { Input } from 'components/Input/Input'
import { useIsMobile } from 'utils/useIsMobile'
import { Amount } from '@kunalabs-io/kai'
import { useCurrentWalletAddress } from 'utils/useCurrentWalletAddress'

const TokenContainer = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    & > svg {
      width: 24px;
      height: 24px;
    }
  }
`

const Token = styled(Typography)`
  color: ${p => p.theme.colors.text.primaryDark};
  margin-left: 8px;
`

const Available = styled(Typography)`
  color: ${p => p.theme.colors.text.secondary};
  margin-right: 8px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-right: 6px;
  }
`

const MaxInfo = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  margin-top: 8px;
`

interface Props {
  disabled?: boolean
  tokenIcon?: string
  tokenSymbol: string
  tokenBalance?: Amount
  handleMaxClick: () => void
  handleHalfClick: () => void
  value: string
  estimate: string
  handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  ref?: React.Ref<HTMLElement>
}

export const TokenInput = ({
  disabled,
  tokenIcon,
  tokenSymbol,
  tokenBalance,
  handleMaxClick,
  handleHalfClick,
  value,
  estimate,
  handleValueChange,
  ref,
}: Props) => {
  const isMobile = useIsMobile()

  const walletAddress = useCurrentWalletAddress()
  const isConnected = !!walletAddress

  const disabledActions = disabled || !isConnected

  return (
    <>
      <div style={{ width: '100%' }}>
        <TokenContainer style={{ display: 'flex', alignItems: 'center' }}>
          {tokenIcon && (
            <img src={tokenIcon} width={24} height={24} alt={tokenSymbol} style={{ borderRadius: '50%' }} />
          )}
          <Token variant={isMobile ? 'description' : 'label2'} fontWeight="bold">
            {tokenSymbol}
          </Token>
          <div style={{ marginLeft: 'auto' }}>
            <Input
              ref={ref}
              placeholder="0.00"
              inputText={value}
              onChange={handleValueChange}
              currency={tokenSymbol}
              disabled={disabledActions}
              style={{ display: 'flex' }}
              // estimatedValue="~ $0.00"
            />
          </div>
        </TokenContainer>
        {isConnected && (
          <MaxInfo>
            <Available variant="caption">
              Available:&nbsp;
              {tokenBalance ? tokenBalance.toNumber().toLocaleString('en-US', { maximumFractionDigits: 20 }) : 0}
            </Available>
            <div
              onClick={handleHalfClick}
              style={{ marginRight: isMobile ? 6 : 10, pointerEvents: disabledActions ? 'none' : 'auto' }}
            >
              <Typography
                variant={isMobile ? 'caption' : 'body'}
                fontWeight="bold"
                style={{ cursor: disabledActions ? 'auto' : 'pointer', textTransform: 'uppercase' }}
              >
                Half
              </Typography>
            </div>
            <div onClick={handleMaxClick} style={{ pointerEvents: disabledActions ? 'none' : 'auto' }}>
              <Typography
                variant={isMobile ? 'caption' : 'body'}
                fontWeight="bold"
                style={{ cursor: disabledActions ? 'auto' : 'pointer', textTransform: 'uppercase' }}
              >
                Max
              </Typography>
            </div>
            <Typography variant="caption" color="secondary" style={{ marginLeft: 'auto' }}>
              {estimate}
            </Typography>
          </MaxInfo>
        )}
      </div>
    </>
  )
}
